
<div *ngIf="isShow" class="_toast" [ngClass]="danger ? 'bg-danger' : 'bg-success'">
  <p class="white-color">{{text}}</p>
</div>
